import { PUBLIC_SWR_KEYS } from "../Utilities/swrKeys";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useCachedSWR } from "../Utilities/useCachedSWR";
// Retrieves delivery addresses data from the cache using SWR; this does not trigger a network request.
// These addresses are (currently) program, plan, and delivery schedule agnostic.
export const useCompanyAddressQuery = () => {
    const { datadogLog } = useLogging();
    const { data, error: fetchError, isLoading, } = useCachedSWR(PUBLIC_SWR_KEYS.COMPANY_ADDRESS, {
        onSuccess: (data) => {
            if (!data.success) {
                datadogLog("Failed to fetch company address.", LogLevel.ERROR, undefined);
                throw new Error("Something unexpected happened while loading address data.");
            }
        },
        onError: (error) => {
            datadogLog("Failed to fetch company address.", LogLevel.ERROR, undefined, error);
        },
    });
    return { data, fetchError, isLoading };
};
